const LINE_POINTS = "0,30 11,22 22,26 33,14 44,19 55,9 66,16 77,6 88,12 100,4";

export const LineChartBackdrop = () => (
  <div className="h-full w-full p-4 text-foreground/20">
    <svg viewBox="0 0 100 40" preserveAspectRatio="none" className="h-full w-full">
      <polyline
        points={LINE_POINTS}
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  </div>
);
